import {
  vorzeichenText,
  tonartTonNamen,
  dominante,
  subdominante,
} from '../domain/tonarten'
import type { Tonart } from '../types'

interface Props {
  tonart: Tonart | null
}

export function InfoPanel({ tonart }: Props) {
  if (!tonart) {
    return (
      <div className="info-panel leer">
        <p>Tippe eine Tonart im Quintenzirkel an, um sie zu erkunden.</p>
      </div>
    )
  }
  const dom = dominante(tonart)
  const sub = subdominante(tonart)
  return (
    <div className="info-panel">
      <h2>{tonart.name}-Dur</h2>
      <dl>
        <dt>Vorzeichen</dt>
        <dd>{vorzeichenText(tonart)}</dd>
        <dt>Tonleiter</dt>
        <dd>{tonartTonNamen(tonart).join(' – ')}</dd>
        <dt>Dominante</dt>
        <dd className="hervorhebung dominante">{dom.name}-Dur</dd>
        <dt>Subdominante</dt>
        <dd className="hervorhebung subdominante">{sub.name}-Dur</dd>
      </dl>
    </div>
  )
}
